export default function getData(listing, searchLocation, schemaTemplate, baseUrl, schemaType) {
  if (listing === void 0) {
    listing = {};
  }
  if (schemaTemplate === void 0) {
    schemaTemplate = {};
  }
  const {
    carSchemaOwnerImage,
    features,
    fuelType,
    id,
    images,
    make,
    model,
    owner,
    priceValidUntil,
    pricingDetail,
    quickViewFeatures,
    specifications,
    style,
    title,
    type,
    vin,
    year
  } = listing;
  let options = '';
  let url = '';
  const salePrice = pricingDetail?.incentive || pricingDetail?.salePrice;
  const msrpPrice = pricingDetail?.msrp || '0';
  const makeName = make?.name || '';
  const modelName = model?.name || '';
  const mileage = specifications?.mileage?.value;
  const price = Number(salePrice && salePrice !== 0 ? salePrice : msrpPrice);
  const privateSeller = owner?.privateSeller;
  if (baseUrl) {
    url = baseUrl + 'cars-for-sale/vehicle/' + id;
  } else {
    url = 'https://www.autotrader.com/cars-for-sale/vehicle/' + id;
  }
  const {
    featureDescription = '',
    priceDescription = ''
  } = schemaTemplate;
  if (features) {
    for (let i = 0; i < features.length; i += 1) {
      options = options + ', ' + features[i];
      if (options.length > 140) {
        break;
      }
    }
    options = featureDescription.replace(/%option/, options.slice(1)).replace(/%price/, price);
  } else {
    options = priceDescription.replace(/%price/, price);
  }
  const location = owner?.location?.address?.city ? `${owner?.location?.address?.city}, ${owner?.location?.address?.state}` : searchLocation;
  const listingQuickViewFeatures = Array.isArray(quickViewFeatures) ? `, ${quickViewFeatures.join(', ')}` : '';
  const vehicleDescription = 'Location: ' + location + '. This ' + year + ' ' + makeName + ' ' + modelName + options + listingQuickViewFeatures;

  // Only build listing schema for Dealer listings if the following attributes are present
  if (!privateSeller && price && mileage && mileage !== '0') {
    return {
      '@context': 'http://schema.org/',
      '@type': schemaType,
      vehicleIdentificationNumber: vin || null,
      name: title,
      mpn: title,
      image: images?.sources?.[0]?.src || '',
      itemCondition: `http://schema.org/${type === 'Certified' ? 'Used' : type}Condition`,
      offers: {
        '@type': 'Offer',
        priceCurrency: 'USD',
        price: price.toFixed(2),
        priceValidUntil,
        availability: 'http://schema.org/InStock',
        url,
        seller: {
          '@context': 'http://schema.org/',
          '@type': 'AutoDealer',
          name: owner?.name || '',
          telephone: owner?.phone?.value || '',
          image: carSchemaOwnerImage,
          address: {
            '@context': 'http://schema.org/',
            '@type': 'PostalAddress',
            addressLocality: owner?.location?.address?.city || '',
            addressRegion: owner?.location?.address?.state || '',
            postalCode: owner?.location?.address?.zip || '',
            streetAddress: owner?.location?.address?.address1 || ''
          }
        }
      },
      brand: {
        '@type': 'Brand',
        name: makeName || ''
      },
      model: modelName || '',
      manufacturer: {
        '@context': 'http://schema.org/',
        '@type': 'Organization',
        name: make
      },
      vehicleModelDate: year,
      driveWheelConfiguration: specifications?.driveType?.value || '',
      vehicleEngine: specifications?.engine?.value || '',
      vehicleTransmission: specifications?.transmission?.value || '',
      color: specifications?.color?.value || '',
      mileageFromOdometer: {
        '@type': 'QuantitativeValue',
        value: mileage,
        unitCode: 'SMI'
      },
      bodyType: style,
      url,
      vehicleInteriorColor: specifications?.interiorColor?.value || '',
      fuelEfficiency: specifications?.mpg?.value || '',
      fuelType,
      sku: id,
      description: vehicleDescription
    };
  }
  return {};
}